<template>
	<!-- 注册协议 -->
	<div class="registXyBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- back -->
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">云锦文学城作者注册协议</p>
				</div>
			</div>
		</van-sticky>
		<div class="txt">
			<h4 style="text-align: center;">声明</h4>
			<p>本站致力于发展网络文学、弘扬匠心创作精神、为热爱创作的作者提供优质的创作平台及发展空间，特此声明：</p>
			<p>注册成为作者的用户必须遵守国家法律法规、不侵犯他人的知识产权及相关权利，请您务必上传自己的原创作品，自觉维护原创网站的创作环境；本网站不会对用户上传的作品内容作任何形式的编辑修改，亦不会从该类作品提供者作者的发布行为中获取任何经济利益。好的创造环境需要大家的维护，本站接受用户监督，且如有用户发现本站作品侵犯他人权利，欢迎来函告知。</p>
			<p>凡在本站注册成为作者并发表或上传作品的用户，应按照本站公布的相关规则进行申请、操作、使用，除非您已阅读悉知并接受本协议所有条款，否则您无权注册成为云锦文学城的作者，您注册成为云锦文学城的作者即视为您已悉知并接受本协议的约束。</p>
			<h4>一、基础释义</h4>
			<p>1.“本站”，指西安云卷云书网络科技有限责任公司（以下简称“本公司”）运营的云锦文学城网站，网址为：www.yjwxc.com</p>
			<p>2.“用户”，指同意本网站（通过网上点击方式同意）用户注册协议、接受本网站所提供服务的注册用户。</p>
			<p>3.“注册作者”，指接受并同意本作者注册协议的用户。</p>
			<p>4.“作品”，指注册作者本人上传、发布或发表在本网站上的以文字、图片等形式创作的文学艺术作品（或其任何章节、片段、评价等），且注册作者对该作品依据《中华人民共和国著作权法》享有著作权（注册作者与本网站另有协议约定作品著作权的除外）。</p>
			<p>5.“合作网站”，指与本网站具有合作或关联关系的网站。</p>
			<h4>二、作者注册</h4>
			<p>1.请您严格按照本网站公布和提示的规则与流程进行作者注册操作。注册成为本网站的注册作者后，您有义务妥善保存您的作者账号和密码，并对您账号进行的活动和行为负法律责任。您完全理解并同意，任何因您自身过错（包括但不限于转让账号、与他人共用、自己泄露等）或您所用的计算机感染病毒或木马等情况而导致账号密码泄漏、遗失或因此带来的其他损失均由您自行承担，本公司及网站不承担任何责任。（除法律责任之外还有出于公平原则或人道主义的责任）</p>
			<p>2.您所使用的笔名以及提供的个人介绍等作者信息，不得含有违反国家法律法规、社会公德及本网站规定的文字，否则本网站有权屏蔽或删除作者账号及其账号下发表的任何内容。</p>
			<p>3.您完全理解并同意，为有效利用网站资源，如您在注册后30天内未上传、发表任何作品文字，或清空、锁定所有作品章节7天以上，或声明离开本网站的，本网站有权不经另行通知无条件删除您在本网站的注册作者账号及该账号下发表的任何内容。 </p>
			<h4>三、作者投稿 </h4>
			<p>1.您应当严格按照本网站公布和提示的规则、说明、流程等进行作品投稿、上传或发布，并愿受其约束。</p>
			<p>2.在本网站上传、发布或发表的作品不得含有下列内容：</p>
			<p>(1)反对宪法确定的基本原则的；</p>
			<p>(2)危害国家统一、主权和领土完整的；</p>
			<p>(3)泄露国家秘密、危害国家安全或损害国家荣誉和利益的；</p>
			<p>(4)煽动民族仇恨、民族歧视，破坏民族团结的，或侵害民族风俗习惯的；</p>
			<p>(5)宣扬邪教，迷信的；</p>
			<p>(6)扰乱社会秩序，破坏社会稳定的</p>
			<p>(7)宣扬淫秽、赌博、暴力，或教唆犯罪的；</p>
			<p>(8)侮辱或者诽谤他人，侵害他人合法权益的；</p>
			<p>(9)危害社会公德或者民族优秀文化传统的；</p>
			<p>(10)有法律、法规规定和其他国家规定禁止的其他内容。</p>
			<p>本网站有权对含有或涉嫌含有上述违法内容的作品或有悖社会道德伦理、政治色彩强烈的作品不予发布，或不经另行通知从网站上将该等作品予以删除，且有权删除注册作者账号及该账号下发表或上传的其他内容。</p>
			<p>3.注册作者应当保证在本网站上传、发表的作品系其本人所创作，内容健康，注重文学品味并符合本网站关于原创文学网站发展的方向和定位。</p>
			<p>4.经本网站核实作品属于非上传者原创、或涉嫌侵犯他人知识产权的作品，将根据本网站的相关规定进行处理。此类作品所产生的一切后果责任由注册作者自行承担。</p>
			<p>本网站谢绝任何形式的转载，严禁剽窃、抄袭，否则责任自负。</p>
			<h4>四、关于稿酬</h4>
			<p>1.您完全理解并同意，除非您与本网站另行签订协议成为本网站的签约作者，本公司和本网站无须就您在本网站上传、发布或发表的任何作品支付稿酬或其他费用。</p>
			<p>2.福利页规定的“完本提现”规则除外。（完本提现由编辑从专业角度审核决定，具体发放情况由编辑、主编审核后按照完本提现规则及相应章程决定。）</p>
			<h4>五、作品授权</h4>
			<p>1.凡在本网站上传、发布或发表的作品，您须根据本网站的后续相关规定选择作品版权授权级别及状态。根据作品授权的不同级别及状态，本公司和本网站对作品拥有一般授权传播、独家发表、优先发表、作品转载等不同的版权权利，请您在填写时仔细阅读并遵守相关规则和说明。</p>
			<p>2.尽管有上述规定，接受本作者注册协议，即表示您同意授权本公司和本网站取得您作品的信息网络传播权，并同意合作网站在本公司和本网站所获授权范围内使用您的作品。 </p>
			<h4>六、免责声明</h4>
			<p>1.凡有本网站用户未经作者许可，在本网站社区论坛内转载作品，本网站对该用户转载行为不负任何责任，但承诺接到注册作者投诉并按照本网站规定的程序核实后，及时删除该贴并对该用户进行警告处理。</p>
			<p>2.属于学习资料性质的扩展版面内容，在无法与作者取得联系的前提下，本网站保证转载后不作为任何商业用途，如作者对此有异议，可以通知本网站将其删除。</p>
			<p>3.您理解并同意，若有人恶意冒充网络作者向本网站投稿，并被本网站接受录入非其原创的作品内容，本公司和本网站不承担任何责任，但保证接到真实作者投诉时，经验证后及时删除该作品及冒充者帐号。</p>
			<p>本网站不保证收录作品稿件的绝对安全性，请注册作者自行留存原稿。</p>
		</div>
		<!-- 底部 -->
		<div class="footer" v-if="urlStr != ''">
			<button v-for="(item,index) in btn" :key="index" :class="btnindex == index ? 'active' : ''" @click="btnFn(index)">{{item}}</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				btnindex: 1, //按钮选中索引
				btn: ["不同意", "同意"],
				urlStr: '',
			}
		},
		created() {
			this.urlStr = this.$route.query.url || '';
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		methods: {
			btnFn(index) {
				this.btnindex = index;
				if (index == 1 && this.urlStr == 'userinfoPage') {
					this.$router.push('/txzl')
				} else if (index == 0 && this.urlStr == 'userinfoPage') {
					this.$router.push('/userinfo')
				}
			},
			back() {
				if (this.urlStr == 'userinfoPage') {
					this.$router.push('/userinfo')
				} else {
					this.$router.push('/set')
				}

			}
		}
	}
</script>

<style lang="less" scoped>
	.registXyBox {
		background-color: #fff;
		height: calc(100vh - 100px);
		width: 100vw;
		overflow-x: hidden;
		color: #000;
	}

	// 头部
	.headerBox {
		height: 160px;
		background-color: #FF4081;
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;/*no*/
		.headerQuery {
			margin-top: 80px;
			padding: 0 20px;
			position: relative;
			display: flex;
			width: 100%;
			height: 80px;
			line-height: 80px;
			color: #000;


			.arrImg {
				img {
					width: 40px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 10px;
				}
			}

			.header_titile {
				flex: 1;
				text-align: center;
				font-size: 34px;
				/*px*/
			}
		}

	}

	.txt {
		padding: 10px 30px;
		p{
			line-height: 50px;
			font-size: 26px;/*px*/
		}
		h4{
			line-height: 50px;
			font-size: 28px;/*px*/
		}
	}

	//底部
	.footer {
		position: fixed;
		bottom: 0;
		width: 100vw;
		display: flex;
		border-top: 1px solid #e5e5e5;

		/*no*/
		button {
			flex: 1;
			padding: 30px 0;
			background-color: #fff;
			border: 0;
			color: #3e3e3e;
			font-size: 34px;
			/*px*/
		}

		button.active {
			background-color: #FF4081;
			color: #ffffff;
		}
	}
</style>
